import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios"; // Make sure to install axios: npm install axios
import API_BASE_URL from "../config";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const Footer = () => {
  const navigate = useNavigate();
  const [siteInfo, setSiteInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openSection, setOpenSection] = useState(null);
  const toggleSection = (section) => {
    if (!isMobile) return; // ❗ disable toggle on desktop
    setOpenSection(openSection === section ? null : section);
  };

  useEffect(() => {
    fetchSiteInfo();
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 576);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchSiteInfo = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}home/info`);

      if (response.data.success) {
        setSiteInfo(response.data.data);
      } else {
        setError("Failed to fetch site information");
      }
    } catch (err) {
      setError("Error fetching site information");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Handle social media clicks
  const handleSocialClick = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  if (loading) {
    return (
      <footer className="footercontainer lazy">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-4">
              <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  if (error) {
    return (
      <footer className="footercontainer lazy">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-4">
              <p className="text-light">{error}</p>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer
      className="footercontainer lazy"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/footer-bg.webp)`,
      }}
    >
      <div className="container">
        <div className="row">
          {/* Logo + Description */}
          <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-4 col-sm-4 col-12 pe-lg-5">
            <div className="footerlogo">
              <div className="footerloginner">
                <Link to="/">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/logo.png`}
                    alt={`${siteInfo?.site_name || "Guestlinkup"} Logo`}
                  />
                </Link>
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    siteInfo?.site_description ||
                    "Ut et pretium felis. Cras in dui nisi. Sed iaculis blandit sagittis. Duis nec ipsum tristique, fringilla tellus a, varius arcu."
                }}
              ></p>

            </div>
          </div>

          {/* Contact Info */}
          <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
            <div className="footernav">
              <h3 onClick={() => toggleSection("contact")} className="toggleCat">
                Contact Information
                {isMobile && (
                  <span style={{ float: "right" }}>
                    {openSection === "contact" ? <FiChevronUp /> : <FiChevronDown />}
                  </span>
                )}
              </h3>

              <div style={{ display: isMobile ? (openSection === "contact" ? "block" : "none") : "block" }}>
                <div className="addressbtx">
                  <div className="addressicon">
                    <i className="icon icon-map-marker"></i>
                  </div>
                  <div className="addresstext">
                    <p>
                      <span dangerouslySetInnerHTML={{ __html: siteInfo.address }} />
                    </p>
                  </div>
                </div>
                <div className="addressbtx envelope">
                  <div className="addressicon">
                    <i className="icon icon-envelope"></i>
                  </div>
                  <div className="addresstext">
                    <p>
                      <a href={`mailto:${siteInfo?.site_email || "info@freedompath.com"}`}>
                        {siteInfo?.site_email || "info@freedompath.com"}
                      </a>
                    </p>
                  </div>
                </div>
                <div className="addressbtx phone">
                  <div className="addressicon">
                    <i className="icon icon-phone"></i>
                  </div>
                  <div className="addresstext">
                    <p>
                      <a style={{ fontSize: "13px" }} href={`tel:${siteInfo?.site_phone || "+491234567890"}`}>
                        {siteInfo?.site_phone || "+49 123 456 7890"}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-12 ps-lg-5">
            <div className="footernav">
              <h3 onClick={() => toggleSection("links")} className="toggleCat">
                Links
                {isMobile && (
                  <span style={{ float: "right" }}>
                    {openSection === "links" ? <FiChevronUp /> : <FiChevronDown />}
                  </span>
                )}
              </h3>

              <ul style={{ display: isMobile ? (openSection === "links" ? "block" : "none") : "block" }}>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                {/* <li>
                  <Link to="/service">Services</Link>
                </li> */}
                {/* <li>
                  <Link to="/blog">Blogs</Link>
                </li> */}
                <li>
                  <Link to="/career">Career</Link>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
                <li>
                  <Link to="/help-center">Help Center</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-conditions">Terms & Conditions</Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Social Links - Updated with API data */}
          <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-12 d-sm-flex justify-content-end">
            <div className="footernav w-sm-auto">
              <h3 onClick={() => toggleSection("social")} className="toggleCat">
                Follow Us
                {isMobile && (
                  <span style={{ float: "right" }}>
                    {openSection === "social" ? <FiChevronUp /> : <FiChevronDown />}
                  </span>
                )}
              </h3>

              <ul style={{ display: isMobile ? (openSection === "social" ? "block" : "none") : "block" }}>
                {siteInfo?.facebook_url && (
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSocialClick(siteInfo.facebook_url);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Facebook
                    </a>
                  </li>
                )}
                {siteInfo?.twitter_url && (
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSocialClick(siteInfo.twitter_url);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Twitter
                    </a>
                  </li>
                )}
                {siteInfo?.instagram_url && (
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSocialClick(siteInfo.instagram_url);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Instagram
                    </a>
                  </li>
                )}
                {siteInfo?.youtube_url && (
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSocialClick(siteInfo.youtube_url);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Youtube
                    </a>
                  </li>
                )}
                {/* Add more social links as needed from your API response */}
                {!siteInfo?.facebook_url && !siteInfo?.twitter_url && !siteInfo?.instagram_url && !siteInfo?.youtube_url && (
                  <>
                    <li>
                      <a href="#" onClick={(e) => e.preventDefault()}>Facebook</a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => e.preventDefault()}>Twitter</a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => e.preventDefault()}>Instagram</a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => e.preventDefault()}>Youtube</a>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="row">
          <div className="col-12">
            <div className="copyrightouter">
              <div className="copyright">
                &copy;{new Date().getFullYear()}{" "}
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    navigate('/');
                  }}
                >
                  {siteInfo?.site_name || "Guestlinkup"}
                </a>. All Rights Reserved.
              </div>

            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;